import { render, staticRenderFns } from "./jobsyoumanage.vue?vue&type=template&id=38a080c8&scoped=true"
import script from "./jobsyoumanage.vue?vue&type=script&lang=js"
export * from "./jobsyoumanage.vue?vue&type=script&lang=js"
import style0 from "./jobsyoumanage.vue?vue&type=style&index=0&id=38a080c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a080c8",
  null
  
)

export default component.exports